import React from 'react';
import PropTypes from 'prop-types';
import './Popup.css';

import PopupTitle from './PopupTitle';
import PopupMedia from './PopupMedia';
import PopupNav from './PopupNav';

function PopupCTA({ title = null, className = null, media = null, indexClass = null, style, mediaClassName = null, cancelClick, children }) {
  const extra = { cancelClick };
  return (
    <div className={`flexColumn popupv2-body ${className}`} style={style}>
      { media && <PopupMedia src={media} className={mediaClassName} /> }
      { title && <PopupTitle label={title} /> }
      { React.Children.map(children, child => (React.isValidElement(child)) && React.cloneElement(child, extra)) }
      {indexClass && <PopupNav indexClass={indexClass} />}
    </div>
  )
}

PopupCTA.propTypes = {
  title: PropTypes.string.isRequired,
  cancelClick: PropTypes.func
}

export default PopupCTA;
